import { requests } from "../index";
import URLS from "../endPoints";
import request from "superagent";
import store from "store.js";
import axios from "axios";

let Home = {};

// magitt Billboard
Home.getBillboard = async () => await requests.get(URLS.magUrl.billboard); //api call

Home.getFeaturedJob = async () => await requests.getWithId(URLS.magUrl.featuredjobs);
//local host --------------------------------------------------------------------------------------
// let ApplicantId = store.getState()?store.getState().Auth.user.MGID:'';
// let config = {
//   headers: {
//     Applicantid: 'A22746027400320940',
//   }
// }
// Home.getFeaturedJob = async () => await axios.get('http://localhost:3001/Career/getFeaturedJobs/1',config);
//local host --------------------------------------------------------------------------------------
Home.groups = async () => await requests.get(URLS.magUrl.groups);
Home.getGroupRelatedJob = async (ids) =>
  await requests.get(URLS.magUrl.groupRealatedJobs + "/" + ids);
Home.portfolio = async () => await requests.get(URLS.magUrl.portfolio);

// Home.getFeaturedJob = async () => await requests.get(URLS.magUrl.featuredjobs)
//getFeaturedJobs/1
// Home.groups = async () => await requests.get(URLS.magUrl.groups)
// Home.getGroupRelatedJob = async (id) => {
//     await requests.get(URLS.magUrl.groupRealatedJobs+ '/' + id)
// }
Home.knowUsMore = async () => await requests.get(URLS.magUrl.portfolio);
// Home.knowUsMore = async () => await requests.get(URLS.magUrl.portfolio);
//suraj banner
Home.getBanner = async () => await requests.get(URLS.magUrl.banner);
Home.getRelatedPortfoliosByID = async (payload) => await requests.post(URLS.magUrl.RelatedPortfolio,payload)
Home.getITV = async () => await requests.post(URLS.magUrl.ITVGet);
Home.getTeamICICI = async () =>
  await requests.postTeamICICI(URLS.magUrl.postBySearch);
Home.getMoreJob = async (payload) =>
  await requests.post(URLS.magUrl.getMoreJobsOnScroll, payload);
Home.getAllCourse = async () => {
  let res = await axios.post("http://localhost:3001/Career/getAllCourses");
  return res;
};



Home.uploadAppResumeMg = async (payload) => {
  await requests.post(URLS.magUrl.uploadAppResumeMg, payload);
};

export default Home;
